// src/components/ServicesBentoMui.jsx
import * as React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "motion/react";

import diseno from "../../images/diseno.jpg?url";
import campanas from "../../images/campanas.jpg?url";
import branding from "../../images/branding.jpg?url";
import contenido from "../../images/contenido.jpg?url";

const MotionBox = motion(Box);

/* DATA */
const images = { diseno, campanas, branding, contenido };
const onClick = { diseno: () => {}, campanas: () => {}, branding: () => {}, contenido: () => {} };

const cards = [
  { slot: "a", size: "lg", key: "diseno",    eyebrow: "Programación",     title: "Desarrollo web",        sub: "Páginas rápidas: e-commerce y soluciones a medida", img: images.diseno,    onClick: onClick.diseno },
  { slot: "b", size: "sm", key: "branding",  eyebrow: "Identidad",        title: "Branding",              sub: "Marcas consistentes y memorables",                  img: images.branding,  onClick: onClick.branding },
  { slot: "c", size: "sm", key: "contenido", eyebrow: "Reels & long format", title: "Creación de contenido", sub: "Fotografía y video profesional",                   img: images.contenido, onClick: onClick.contenido },
  { slot: "d", size: "lg", key: "campanas",  eyebrow: "Crecimiento",      title: "Campañas publicitarias", sub: "MetaAds y Google Ads con medición y eventos",       img: images.campanas,  onClick: onClick.campanas },
];

/* Animaciones */
const gridVariants = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.12 } } };
const tileVariants = { hidden: { opacity: 0, y: 24, scale: 0.98 }, show: { opacity: 1, y: 0, scale: 1, transition: { type: "spring", stiffness: 120, damping: 16 } } };

/* Tile */
function Tile({ img, eyebrow, title, sub, size = "sm", onClick }) {
  const isLg = size === "lg";
  return (
    <MotionBox
      variants={tileVariants}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : -1}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.995 }}
      transition={{ type: "spring", stiffness: 260, damping: 22 }}
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        borderRadius: 2,
        cursor: onClick ? "pointer" : "default",
        boxShadow: "0 10px 30px rgba(0,0,0,.25), 0 0 0 1px rgba(243,90,58,.20), 0 0 18px 0 rgba(243,90,58,.10)",
        isolation: "isolate",
        willChange: "transform",
        transformOrigin: "center",
        "& .bg": {
          position: "absolute", inset: 0,
          backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center",
          transform: "scale(1)", transition: "transform .4s ease", willChange: "transform",
        },
        "& .vignette": {
          position: "absolute", inset: 0,
          background: "radial-gradient(80% 80% at 50% 65%, transparent 0%, rgba(0,0,0,.35) 60%, rgba(0,0,0,.55) 100%)",
          zIndex: 1, pointerEvents: "none",
        },
        "& .shine": {
          position: "absolute", inset: "-40%",
          background: "linear-gradient(120deg, transparent 45%, rgba(255,255,255,.25) 50%, transparent 55%)",
          transform: "translateX(-120%) rotate(5deg)", zIndex: 2, pointerEvents: "none", transition: "transform .8s ease",
        },
        "&::after": { content: '""', position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(0,0,0,.32), rgba(0,0,0,.68))", zIndex: 1 },
        "&:hover .bg": { transform: "scale(1.06)" },
        "&:hover .shine": { transform: "translateX(120%) rotate(5deg)" },
        "&:hover": { zIndex: 5 },
      }}
    >
      <Box className="bg" />
      <Box className="vignette" />
      <Box className="shine" />
<Box
  sx={{
    position: "relative",
    zIndex: 3,
    color: "common.white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    height: "100%",
    p: { xs: 2, md: 2.5, lg: 3 },
    gap: 0.75,
    textShadow: "0 2px 18px rgba(0,0,0,.75), 0 6px 30px rgba(0,0,0,.65)",
  }}
>
  {eyebrow && (
    <Typography
      // eyebrow consistente
      variant="caption"
      sx={{
        textTransform: "uppercase",
        letterSpacing: 1.5,
        fontWeight: 800,
        color: "rgba(243,90,58,.98)",
        textShadow: "0 0 14px rgba(243,90,58,.55), 0 0 2px rgba(0,0,0,.7)",
        fontSize: { xs: ".75rem", md: ".8rem" }, // 12–13px aprox
      }}
    >
      {eyebrow}
    </Typography>
  )}

  <Typography
    // unificamos variant y controlamos con fontSize
    variant="h4"
    sx={{
      fontWeight: 900,
      letterSpacing: "-.02em",
      lineHeight: 1.05,
      // XS: todas iguales; MD+: las "lg" crecen apenas
      fontSize: {
        xs: "clamp(1.8rem, 6vw, 2.2rem)",                 // ~28–35px
        md: isLg ? "clamp(2.2rem, 2.6vw, 3rem)"           // ~35–48px
                 : "clamp(1.8rem, 2.1vw, 2.4rem)",        // ~28–38px
      },
    }}
  >
    {title}
  </Typography>

  {sub && (
    <Typography
      // subtítulo coherente en todas
      variant="body1"
      sx={{
        opacity: 0.98,
        maxWidth: isLg ? 560 : 480,
        pb: 4,
        fontSize: {
          xs: "clamp(.95rem, 3.6vw, 1.05rem)",            // ~15–17px
          md: "1rem",
        },
        lineHeight: 1.4,
      }}
    >
      {sub}
    </Typography>
  )}
</Box>

    </MotionBox>
  );
}

/* Grid */
export default function ServicesBentoMui() {
  return (
    <MotionBox
      component="section"
      variants={gridVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
      sx={{
        position: "relative",
        isolation: "isolate",
        width: "100%",
        height: { xs: "auto", md: "auto" },

        /* XS: full-bleed */
        px: { xs: 0, md: 0 },
        py: 0,
        ml: { xs: "calc(50% - 50vw)", md: 0 },
        mr: { xs: "calc(50% - 50vw)", md: 0 },

        /* ≥ md: contenedor centrado con padding y ancho máximo */
        maxWidth: "90%",  // ajustá si querés
        mx: { md: "auto" },                // centra todo en desktop
        px: 2,              // padding lateral en desktop (≈24/32px)

        display: "grid",
        rowGap: 2,
        columnGap: { xs: 0, md: 2 },
        gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
        justifyItems: "stretch",
        alignItems: "stretch",

        gridAutoRows: "minmax(220px, 1fr)",
        overflow: "visible",
        mb: { xs: 8, md: 8 },

        "@media (min-width:1024px)": {
          minHeight: "80vh",
          gridTemplateColumns: "repeat(12, 1fr)",
          gridTemplateRows: "repeat(12, minmax(0, 1fr))",
          gridAutoRows: "unset",
        },

        "& .a": { "@media (min-width:1024px)": { gridColumn: "1 / span 7", gridRow: "1 / span 7" } },
        "& .b": { "@media (min-width:1024px)": { gridColumn: "8 / span 5", gridRow: "1 / span 4" } },
        "& .c": { "@media (min-width:1024px)": { gridColumn: "1 / span 7", gridRow: "8 / span 5" } },
        "& .d": { "@media (min-width:1024px)": { gridColumn: "8 / span 5", gridRow: "5 / span 8" } },
      }}
    >
      {cards.map((card) => (
        <Box
          key={card.key}
          className={card.slot}
          sx={{
            /* XS: centrada con padding simétrico; ≥md: ocupar 100% de la celda */
            width: { xs: "min(640px, calc(100vw - 32px))", md: "100%" },
            mx: { xs: "auto", md: 0 },
          }}
        >
          <Tile
            img={card.img}
            eyebrow={card.eyebrow}
            title={card.title}
            sub={card.sub}
            size={card.size}
            onClick={card.onClick}
          />
        </Box>
      ))}
    </MotionBox>
  );
}
